import React from 'react';
import styled from 'styled-components';

const Span = styled.span<Span>`
  display: inline-block;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  ${({ theme }) => theme.mq.md`
    font-size: 2rem;
    padding: 1rem 2rem;
    border-radius: 4rem;      
  `}
  background-color: ${({ theme, active }) => (active ? theme.themeColors.fg : 'transparent')};
  color: ${({ theme, active }) => (active ? theme.themeColors.bg : theme.themeColors.fg)};
  border: 2px solid ${({ theme }) => theme.themeColors.fg};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, active, hover }) => hover && !active && theme.themeColors.fg};
    color: ${({ theme, active, hover }) => hover && !active && theme.themeColors.bg};
  }
`;

interface Span {
  active?: boolean;
  hover?: boolean;
}

interface Chip extends Span {
  text?: string;
  className?: string;
  onEnter?: React.MouseEventHandler<HTMLElement>;
  onExit?: React.MouseEventHandler<HTMLElement>;
}

const Chip: React.FC<Chip> = ({
  text = '',
  active = false,
  hover = false,
  className = '',
  onEnter = undefined,
  onExit = undefined
}) => {
  return (
    <Span
      active={active}
      hover={hover}
      className={className}
      onMouseEnter={onEnter}
      onMouseLeave={onExit}
    >
      {text}
    </Span>
  );
};

export default Chip;
